import {
  selectConnectionQualityByPeerID,
  selectLocalPeer,
  useHMSStore,
} from "@100mslive/react-sdk";
import type { ProviderLocalSignal } from "../types";

export const useHMSLocalSignal = (): ProviderLocalSignal => {
  const localPeer = useHMSStore(selectLocalPeer);
  const localPeerDownlinkQuality = useHMSStore(
    selectConnectionQualityByPeerID(localPeer?.id),
  )?.downlinkQuality;

  return {
    localPeerDownlinkQuality,
  };
};
